<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16lbnEh/tc-custom/9781633224827.jpg?1726519344964" alt="This image is the cover for the book Art Starts with a Line"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Art Starts with a Line
      </h1>
      <p class="bookDescription body article font2">
        <b>Everything you need to master the art of line drawing, whether the goal is to draw for fun or illustrate an original masterpiece!</b><br/><br/>Line drawing involves using a combination of fine lines and bold strokes to create artwork of any kind—from basic folk art to more sophisticated illustrations. This form of art requires minimal tools, making it both affordable and portable. In <i>Art Starts with a Line</i>, artists of all skill levels are invited to learn how to draw almost anything starting with simple lines and basic shapes.<br/><br/>Following a brief introduction to tools and materials, as well as some easy exercises and techniques for warming up to basic drawing tools, you will explore a variety of subjects. You’ll draw plants and flowers, architecture and cityscapes, animals, and everything in between. These projects aren’t restricted to black and white either! You’ll find techniques for adding color with colored pencil, marker, pen, even digitally.<br/><br/><i>Art Starts with a Line</i> presents everything you’ll need to know to learn how to successfully create line drawings of all types. Whether your goal is to create a custom logo for a client, or to simply decorate your planner—it’s all here. Packed with engaging instruction, tips, and beautiful step-by-step artwork, this approachable, inspiring guide to line drawing shows beginning artists how to create meaningful artwork using simple lines and mindful prompts.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Erin McManness
      </h2>
      
      <p class="authorDescription body article">Artist Erin McManness is a graduate of the Savannah College of Art and Design, where she earned a master's degree in illustration. She has been living and working in the arts in the Atlanta area for 6 years and is currently running her own business, stationery, and illustration line, Paper Raven Co. McManness works on a variety of different projects in addition to her paper goods line, taking on books, murals, branding projects, home decor projects, and advocating for the development of the arts in Atlanta neighborhoods. Find more from Erin at shoppaperravenco.com and Instagram @paperraven.co.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Walter Foster Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0b47d76e